<template>
  <div :class="container_class" :style="container_style">
    <img @click="toggleShow" :style="image_style" :class="image_class" :src="imgDataUrl" />
    <div
            @click="toggleShow"
            style="cursor:pointer;position: absolute;text-align: center;left: 74px;top: 121px;"
    >
      <i class="fa fa-camera" style="position: absolute;" aria-hidden="true"></i>
      <div
              v-show="imgDataUrl=='' || imgDataUrl==null || imgDataUrl == undefined"
              style="position: absolute;width:100px;bottom: 41px;left: -40px;font-weight: 100;text-align: center;"
              aria-hidden="true"
      >{{label}}</div>
    </div>
    <my-upload
      v-if="show"
      field="img"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess"
      @crop-upload-fail="cropUploadFail"
      v-model="show"
      :width="200"
      :height="200"
      :url="'/api/v1/upload/avatar?api_token=' + api_token"
      :params="params"
      :headers="headers"
      img-format="png"
      langType="en"
      :noRotate="false"
      :noSquare="false"
      :noCircle="false"
    ></my-upload>
  </div>
</template>

<script>
import myUpload from "vue-image-crop-upload";
export default {
  components: {
    "my-upload": myUpload
  },
  props: {
    avatar_url: {
      type: String,
      required: true
    },
    container_class: {
      type: String
    },
    container_style: {
      type: String
    },
    image_class: {
      type: String
    },
    image_style: {
      type: String
    }
  },
  data() {
    return {
      show: false,
      params: {
        token: "123456798",
        name: "avatar"
      },
      headers: {
        smail: "*_~"
      },
      imgDataUrl: this.avatar_url, // the datebase64 url of created image
      api_token: window.api_token
    };
  },
  methods: {
    toggleShow() {
      this.show = !this.show;
    },
    /**
     * crop success
     *
     * [param] imgDataUrl
     * [param] field
     */
    cropSuccess(imgDataUrl, field) {
      console.log("-------- crop success --------");
      this.imgDataUrl = imgDataUrl;
    },
    /**
     * upload success
     *
     * [param] jsonData  server api return data, already json encode
     * [param] field
     */
    cropUploadSuccess(jsonData, field) {
      console.log("-------- upload success --------");
      console.log(jsonData);
      console.log("field: " + field);
      let self = this;
      setTimeout(function() {
        self.show = false;
      }, 1000);
    },
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail(status, field) {
      console.log("-------- upload fail --------");
      console.log(status);
      console.log("field: " + field);
      setTimeout(function() {
        self.show = false;
      }, 1000);
    }
  }
};
</script>
